import { ChangeDetectorRef, OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, NgControl, } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { identifier } from '@uipath/angular/utilities';
import UiValidators from '@validators';
import { merge, Subject, } from 'rxjs';
import { map, takeUntil, } from 'rxjs/operators';
var UiTimeOffsetPickerComponent = /** @class */ (function () {
    function UiTimeOffsetPickerComponent(ngControl, _cd, _fb) {
        var _this = this;
        this.ngControl = ngControl;
        this._cd = _cd;
        this._fb = _fb;
        this.disabled = false;
        this.daysPlaceholder = 'Days';
        this.hoursPlaceholder = 'Hours';
        this.daysRange = { min: 0, max: 90 };
        this.hoursRange = { min: 0, max: 23 };
        /**
         * Custom error list that component will validate against
         *
         * @type {ErrorRecord[]}
         * @memberof UiTimeOffsetPickerComponent
         */
        this.errorsToCheck = [];
        this.stateChanges = new Subject();
        this.placeholder = '';
        this.labelText = '';
        this.focused = false;
        this.empty = false;
        this.shouldLabelFloat = false;
        this.describedBy = '';
        this.errorState = false;
        this.daysErrorStateMatcher = {
            isErrorState: function () {
                return _this.form.get('days').hasError('range') ? true : _this._hasError();
            },
        };
        this.hoursErrorStateMatcher = {
            isErrorState: function () {
                return _this.form.get('hours').hasError('range') ? true : _this._hasError();
            },
        };
        this._value = 0;
        this._required = false;
        this._destroyed$ = new Subject();
        this.registerChange = function () { };
        this.registerTouch = function () { };
        this.ngControl.valueAccessor = this;
        this._randomName = identifier();
        this.id = 'ui-time-offset-picker-' + this._randomName;
    }
    Object.defineProperty(UiTimeOffsetPickerComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (state) {
            this._value = state;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiTimeOffsetPickerComponent.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (req) {
            this._required = req;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    UiTimeOffsetPickerComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    UiTimeOffsetPickerComponent.prototype.onContainerClick = function (_event) { };
    UiTimeOffsetPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form = this._fb.group({
            days: [this._days, UiValidators.range(this.daysRange.min, this.daysRange.max)],
            hours: [this._hours, UiValidators.range(this.hoursRange.min, this.hoursRange.max)],
        });
        merge(this.form.get('days').valueChanges, this.form.get('hours').valueChanges).pipe(map(function (_) { return _this.form.get('days').value * 1440 + _this.form.get('hours').value * 60; }), takeUntil(this._destroyed$)).subscribe(function (value) {
            _this.registerChange(value);
            _this.value = value;
            _this._setErrors();
            _this._cd.markForCheck();
        });
    };
    UiTimeOffsetPickerComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this.stateChanges.complete();
    };
    UiTimeOffsetPickerComponent.prototype.writeValue = function (minutes) {
        this.value = minutes;
        if (this.form) {
            this.form.get('days').setValue(this._days, { emitEvent: false });
            this.form.get('hours').setValue(this._hours, { emitEvent: false });
        }
        this._setErrors();
        this._cd.markForCheck();
    };
    UiTimeOffsetPickerComponent.prototype.registerOnChange = function (fn) {
        this.registerChange = fn;
    };
    UiTimeOffsetPickerComponent.prototype.registerOnTouched = function (fn) {
        this.registerTouch = fn;
    };
    Object.defineProperty(UiTimeOffsetPickerComponent.prototype, "_days", {
        get: function () {
            return Math.floor(this._value / 1440);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiTimeOffsetPickerComponent.prototype, "_hours", {
        get: function () {
            return Math.floor((this._value % 1440) / 60);
        },
        enumerable: true,
        configurable: true
    });
    UiTimeOffsetPickerComponent.prototype._hasError = function () {
        var _this = this;
        this.errorToDisplay = this.errorsToCheck
            .find(function (_a) {
            var error = _a.error;
            return _this.ngControl.hasError(error);
        });
        return !!this.errorToDisplay;
    };
    UiTimeOffsetPickerComponent.prototype._setErrors = function () {
        if (this.ngControl &&
            this.form &&
            (this.form.get('days').errors || this.form.get('hours').errors)) {
            this.ngControl.control.setErrors({ invalid: true });
            this.stateChanges.next();
        }
    };
    return UiTimeOffsetPickerComponent;
}());
export { UiTimeOffsetPickerComponent };
